<template>
  <a-card :bordered='false' class='main_box' size='small'>
    <div class='table-operator'>
      <a-radio-group v-model="baseQueryParam.type" @change="searchQuery">
        <a-radio-button value="1">
          系统质疑
        </a-radio-button>
        <a-radio-button value="2">
          终止随访
        </a-radio-button>
        <a-radio-button value="3">
          其它规则
        </a-radio-button>
      </a-radio-group>
      <a-button icon='plus' style="margin-left: 20px" type='primary' @click='handleAddMy( )'>新增</a-button>
      <a-button icon='plus' type='primary' @click='handleAddExist()'  style="margin-left: 8px">复制已有</a-button>
    </div>
    <div>
      <a-table :columns='columns'
               :dataSource='dataSource'
               :loading='loading'
               :pagination='ipagination'
               rowKey='id'
               size='small'
               @change='handleTableChange'>
        <span slot='action' slot-scope='text, record'>
         <a-button size='small' type='primary' @click='handleStop(record.id , record.status==="1"?"0":"1")'>{{record.status==='1'?'停用':'启用'}}</a-button>
         <a-divider type='vertical' />
           <a-button size='small' type='primary' @click='handleEdit(record)'>编辑</a-button>
         <a-divider type='vertical' />
          <a-popconfirm title='确定删除吗?' @confirm='() => handleDelete(record.id)'>
            <a-button size='small' type='danger'>删除</a-button>
          </a-popconfirm>
        </span>        
        <template slot="formTip" slot-scope="text, record">
          <a-tooltip>
            <template slot="title">
              {{record.formName + (record.formDes?"—"+record.formDes:'')}}
            </template>
            {{record.formName}}
          </a-tooltip>
        </template>
      </a-table>
    </div>
    <sys-question-model ref="modalForm" @ok="modalFormOk" :projectId="projectId"></sys-question-model>
    <add-exist ref="addExist" @handleSelect="addExistSelect" :type="baseQueryParam.type"></add-exist>
  </a-card>
</template>

<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import SysQuestionModel from '@views/project/setting/sysQuestion/SysQuestionModel'
  import { CACHE_PROJECT_ID,CACHE_PROJECT_NAME } from '@/constants/project'
  import { getAction,postAction } from '@/api/manage'
  import Vue from 'vue'
  import AddExist from './sysQuestion/addexist/AddExist'
  export default {
    name: 'SysQuestion',
    components: { SysQuestionModel,AddExist },
    mixins: [JeecgListMixin],
    data() {
      return {
        url: {
          list: '/project/projectSysQuestion/list',
          delete: '/project/projectSysQuestion/delete',
        },
        projectId:Vue.ls.get(CACHE_PROJECT_ID) ||'',
        disableMixinCreated: true
      }
    },
    computed: {
      columns() {
        return [
          {
            title: '#',
            align: 'center',
            width: 80,
            customRender: (text, record, index) => index + 1
          },
          {
            title: '质疑表单',
            dataIndex: 'formName',
            width: 200,
            ellipsis: true,
            scopedSlots: { customRender: 'formTip' },
          },
          {
            title: '质疑元素',
            dataIndex: 'formItemName',
            width: 200,
            ellipsis: true
          },
          {
            title: '周期',
            dataIndex: 'periodType',
            width: 200,
            ellipsis: true,
            customRender:(text,record)=>{
              if(text ==='1'){
                return '所有周期'
              }else{
                return record.periodItemName
              }
            }
          },
          {
            title: '质疑说明',
            dataIndex: 'description',
            ellipsis: true
          },
          {
            title: '创建时间',
            dataIndex: 'createTime',
            width: 200,
            ellipsis: true
          },
          {
            title: '操作',
            width: 200,
            scopedSlots: { customRender: 'action' },
          }
        ]
      }
    },
    created() {
      this.baseQueryParam = {
        projectId:this.projectId,
        type:'1'
      }
      this.loadData()
    },

    methods: {
      addExistSelect(record){
      postAction('/project/projectSysQuestion/copyByExist',{
        projectId:this.projectId,
        existId:record.id
      }).then(res=>{
        if(res.success){
          this.$message.success(res.message)
          this.loadData()
        }else{
          this.$message.error(res.message)
        }
      })
    },

      /**
       * 停用
       */
      handleStop(id,status) {
        postAction('/project/projectSysQuestion/editStatus',{id:id,status:status}).then(res=>{
          if(res.success){
            this.loadData()
          }
        })
      },
      handleAddMy(){
        this.handleEdit({
          type:this.baseQueryParam.type
        })
      },
      handleAddExist(){
        this.$refs.addExist.open()
      },
    }

  }
</script>

<style scoped lang="less">
@import '~@/assets/less/common.less';
</style>
